import cn from "classnames"
import React, { useCallback } from "react"
import useMedia from "@/common/hooks/use_media"
import tailwindTheme from "@/common/styles/theme.module.css"
import useTooltip from "@/signomatic/components/tooltip"

interface RowButtonProps {
  tooltip?: string
  iconButton?: boolean
  className?: string
  disableTooltip?: boolean
  "data-gtm"?: string
}

const ForwardableRowButton: React.ForwardRefRenderFunction<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & RowButtonProps
> = ({ tooltip, iconButton, className, disableTooltip, children, ...props }, ref) => {
  const [setTooltipShow, setTooltipHide, tooltipElement] = useTooltip(tooltip || "")

  const handleMouseEnter = useCallback(() => {
    if (tooltip) {
      setTooltipShow()
    }
  }, [setTooltipShow, tooltip])

  const handleMouseLeave = useCallback(() => {
    if (tooltip) {
      setTooltipHide()
    }
  }, [setTooltipHide, tooltip])

  const isDesktop = useMedia(`(min-width: ${tailwindTheme.screensXl})`)

  const dataGtm = props["data-gtm"]
  delete props["data-gtm"]

  return (
    <button
      className={cn("row-button", className, { icon_button: iconButton })}
      type="button"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      data-gtm={dataGtm}
      {...props}
      ref={ref}
    >
      {!disableTooltip && isDesktop && tooltipElement}
      {children}
    </button>
  )
}

const RowButton = React.forwardRef(ForwardableRowButton)

export default RowButton
